import { Controller } from "@hotwired/stimulus"

// 주문 선택 모달 컨트롤러 (검색 기능 포함)
export default class extends Controller {
  static targets = ["modal", "input", "selectedName", "searchInput", "list"]
  static values = {
    orders: Array
  }

  connect() {
    this.updateDisplay()
  }

  openModal(event) {
    event.preventDefault()
    this.renderList()
    this.modalTarget.showModal()
    // 검색 입력 필드에 포커스
    setTimeout(() => {
      if (this.hasSearchInputTarget) {
        this.searchInputTarget.focus()
      }
    }, 100)
  }

  closeModal() {
    this.modalTarget.close()
  }

  search(event) {
    const query = event.target.value.toLowerCase().trim()
    this.renderList(query)
  }

  renderList(query = '') {
    const orders = this.ordersValue
    const filteredOrders = query
      ? orders.filter(o =>
          o.order_number.toLowerCase().includes(query) ||
          o.customer_name.toLowerCase().includes(query)
        )
      : orders

    if (filteredOrders.length === 0) {
      this.listTarget.innerHTML = `
        <div class="text-center py-8 text-gray-500">
          <p>검색 결과가 없습니다</p>
        </div>
      `
      return
    }

    const currentValue = this.inputTarget.value

    // "선택 안함" 옵션
    let blankOption = ''
    if (!query) {
      const isSelected = !currentValue || currentValue === ''
      blankOption = `
        <button type="button"
                class="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition-colors ${isSelected ? 'bg-blue-50' : ''}"
                data-action="click->order-select-modal#clearSelection">
          <div class="text-left">
            <p class="font-medium text-gray-500">선택 안함</p>
          </div>
          ${isSelected ? `
            <svg class="w-5 h-5 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
            </svg>
          ` : ''}
        </button>
      `
    }

    this.listTarget.innerHTML = blankOption + filteredOrders.map(order => `
      <button type="button"
              class="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition-colors ${order.id.toString() === currentValue ? 'bg-blue-50' : ''}"
              data-action="click->order-select-modal#selectOrder"
              data-id="${order.id}"
              data-label="${order.order_number} - ${order.customer_name}">
        <div class="text-left">
          <p class="font-medium text-gray-900">${order.order_number}</p>
          <p class="text-sm text-gray-500">${order.customer_name} · ${order.delivery_date}</p>
        </div>
        ${order.id.toString() === currentValue ? `
          <svg class="w-5 h-5 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
          </svg>
        ` : ''}
      </button>
    `).join('')
  }

  clearSelection() {
    this.inputTarget.value = ''
    this.selectedNameTarget.textContent = '주문 선택 (선택사항)'
    this.selectedNameTarget.classList.add('text-gray-400')
    this.selectedNameTarget.classList.remove('text-gray-900')

    this.closeModal()

    // Change 이벤트 발생
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  selectOrder(event) {
    const id = event.currentTarget.dataset.id
    const label = event.currentTarget.dataset.label

    this.inputTarget.value = id
    this.selectedNameTarget.textContent = label
    this.selectedNameTarget.classList.remove('text-gray-400')
    this.selectedNameTarget.classList.add('text-gray-900')

    this.closeModal()

    // Change 이벤트 발생
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  updateDisplay() {
    const currentValue = this.inputTarget.value
    if (currentValue) {
      const order = this.ordersValue.find(o => o.id.toString() === currentValue)
      if (order && this.hasSelectedNameTarget) {
        this.selectedNameTarget.textContent = `${order.order_number} - ${order.customer_name}`
        this.selectedNameTarget.classList.remove('text-gray-400')
        this.selectedNameTarget.classList.add('text-gray-900')
      }
    }
  }

  // ESC 키로 모달 닫기
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }

  // 모달 외부 클릭 시 닫기
  handleBackdropClick(event) {
    if (event.target === this.modalTarget) {
      this.closeModal()
    }
  }
}
